<div class="content-pane">
  @if(isCreating){
  <h2>Add {{ model?.dataset_type || 'New' }} Dataset</h2>
  } @else {
  <h2>Edit Dataset Details</h2>
  }
  <mat-horizontal-stepper #stepper>
    <mat-step
      [completed]="model?.dataset_type"
      [editable]="false"
      [label]="model?.dataset_type ? 'Type: ' + (model.dataset_type) : 'Type'"
    >
      <mat-radio-group
        class="vertical"
        required
        [value]="model.dataset_type"
        (change)="model.dataset_type = $event.value"
      >
        <mat-radio-button value="Generic"
          >Generic
          <aside>Data is in a table in a file, such as CSV, XML, or JSON.</aside>
        </mat-radio-button>
        <mat-radio-button value="DICOM"
          >DICOM
          <aside>Data is a medical image file.</aside>
        </mat-radio-button>
        <mat-radio-button value="REDCap"
          >REDCap
          <aside>Data is collected via the REDCap survey system and should be updated live.</aside>
        </mat-radio-button>
      </mat-radio-group>
      <div class="form-actions">
        <a href="javascript:window.history.go(-1)" matButton="tonal"
          ><mat-icon class="material-symbols-outlined">chevron_left</mat-icon>Cancel</a
        >
        <button matButton="filled" matStepperNext type="button"
          ><mat-icon class="material-symbols-outlined">chevron_right</mat-icon> Next</button
        >
      </div>
    </mat-step>
    <mat-step [stepControl]="overviewFormGroup" label="Overview">
      <form [formGroup]="overviewFormGroup" (ngSubmit)="handleBrowserSubmit($event)">
        <formly-form
          [model]="model"
          [fields]="overviewFormFields"
          [options]="overviewFormOptions"
          [form]="overviewFormGroup"
          class="standard"
        ></formly-form>
        <div class="form-actions">
          <button matButton="tonal" type="button" (click)="handleBackFromStep2($event)"
            ><mat-icon class="material-symbols-outlined">chevron_left</mat-icon> Cancel</button
          >
          <button matButton="filled" type="button" (click)="validateAndNext()"
            ><mat-icon class="material-symbols-outlined">chevron_right</mat-icon> Next</button
          >
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="dataContentsFormGroup" label="Data Contents">
      <form [formGroup]="dataContentsFormGroup" (ngSubmit)="handleBrowserSubmit($event)">
        <formly-form
          [model]="model"
          [fields]="dataContentsFormFields"
          [options]="dataContentsFormOptions"
          [form]="dataContentsFormGroup"
          class="standard"
        ></formly-form>
        <div class="form-actions">
          <button matButton="tonal" matStepperPrevious type="button"
            ><mat-icon class="material-symbols-outlined">chevron_left</mat-icon> Back</button
          >
          <button matButton="filled" type="button" (click)="validateAndNext()"
            ><mat-icon class="material-symbols-outlined">chevron_right</mat-icon> Next</button
          >
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="regulatoryFormGroup" label="Regulatory">
      <form [formGroup]="regulatoryFormGroup" (ngSubmit)="handleBrowserSubmit($event)">
        <formly-form
          [model]="model"
          [fields]="regulatoryFormFields"
          [options]="regulatoryFormOptions"
          [form]="regulatoryFormGroup"
          class="standard"
          #sec
        ></formly-form>
        <div class="form-actions">
          <button matButton="tonal" matStepperPrevious type="button"
            ><mat-icon class="material-symbols-outlined">chevron_left</mat-icon> Back</button
          >
          <button matButton="filled" type="button" (click)="submit($event)"
            ><mat-icon class="material-symbols-outlined">check</mat-icon> Submit</button
          >
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>
